module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/upload-file-document/upload-file-document.component.scss
// module id = ./src/app/shared/components/upload-file-document/upload-file-document.component.scss
// module chunks = main